import { apiFetch } from "./client";

export interface MigrationState {
  phase: "preparing" | "swapping" | "verifying" | "rolling_back" | "done" | "failed";
  fromAdapter: string;
  toAdapter: string;
  startedAt: string;
  completedAt?: string;
  error?: string;
  log?: string;
  snapshot?: {
    adapterType: string;
    adapterConfig: Record<string, unknown> | null;
  };
}

export interface PreparePlan {
  ok: true;
  fromAdapter: string;
  toAdapter: string;
  warnings: string[];
}

export const adminMigrationApi = {
  get: (agentId: string) =>
    apiFetch<{ state: MigrationState | null }>(`/admin/agents/${agentId}/migrate`),

  prepare: (agentId: string, toAdapter: string) =>
    apiFetch<PreparePlan>(`/admin/agents/${agentId}/migrate/prepare`, {
      method: "POST",
      body: JSON.stringify({ toAdapter }),
    }),

  execute: (agentId: string) =>
    apiFetch<{ ok: boolean; log?: string; error?: string }>(
      `/admin/agents/${agentId}/migrate/execute`,
      {
        method: "POST",
        body: JSON.stringify({}),
      },
    ),

  rollback: (agentId: string, reason?: string) =>
    apiFetch<{ ok: boolean; error?: string }>(`/admin/agents/${agentId}/migrate/rollback`, {
      method: "POST",
      body: JSON.stringify({ reason }),
    }),

  clear: (agentId: string) =>
    apiFetch<{ ok: boolean }>(`/admin/agents/${agentId}/migrate/clear`, {
      method: "POST",
      body: JSON.stringify({}),
    }),
};
